module.exports = __webpack_public_path__ + "static/virtual-reality-jonathan-agoot-13d0ae6427c119322e1bff7ce1217574.jpg";